class NovaMixMatch extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.pf = this.closest('product-form');
    this.count = 1;
    this.catalog = JSON.parse(this.querySelector('[data-mix-catalog]').textContent);
    this.slots = [...this.querySelectorAll('[data-mix-slot]')];
    this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency });
    this.slots.forEach(slot => this.populate(slot));
    this.createPicker();
    this.slots.forEach(slot => {
      for (const kind of ['product', 'variant']) {
        const select = slot.querySelector(`[data-mix-${kind}]`);
        select.hidden = true;
        select.tabIndex = -1;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `mix-match__choose mix-match__choose--${kind}`;
        button.dataset.mixChoose = kind;
        button.setAttribute('aria-haspopup', 'dialog');
        button.addEventListener('click', () => this.openPicker(slot, kind, button));
        select.after(button);
      }
    });
    this.onChange = event => {
      if (event.target.matches('input[type="radio"]')) {
        this.count = Number(event.target.value);
        if (this.count > 1) {
          const variant = this.pf?.getSelectedVariant?.();
          const first = this.slots[0];
          first.querySelector('[data-mix-product]').value = String(this.catalog[0].id);
          this.populate(first, variant?.id);
        }
        this.syncQuantity();
      }
      if (event.target.matches('[data-mix-product]')) this.populate(event.target.closest('[data-mix-slot]'));
      this.render();
    };
    this.addEventListener('change', this.onChange);
    this.onVariant = event => {
      if (this.count > 1) {
        const first = this.slots[0];
        first.querySelector('[data-mix-product]').value = String(this.catalog[0].id);
        this.populate(first, event.detail.variant?.id);
      }
      this.render();
    };
    this.pf?.addEventListener('variant:change', this.onVariant);
    this.onQuantity = event => {
      if (event.target.matches('input[name="quantity"]') && !this.syncing && this.count > 1) {
        this.count = 1;
        this.querySelector('input[value="1"]').checked = true;
        this.render();
      }
      if (event.target.matches('[data-selling-plan], [data-purchase-option]')) this.render();
    };
    this.pf?.addEventListener('change', this.onQuantity);
    this.render();
  }
  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    this.pf?.removeEventListener('variant:change', this.onVariant);
    this.pf?.removeEventListener('change', this.onQuantity);
    if (this.dialog?.open) this.dialog.close();
    this.dialog?.remove();
    this.slots?.forEach(slot => {
      slot.querySelectorAll('[data-mix-choose]').forEach(button => button.remove());
      slot.querySelectorAll('select').forEach(select => { select.hidden = false; select.tabIndex = 0; });
    });
    this.ready = false;
  }
  createPicker() {
    this.dialog = document.createElement('dialog');
    this.dialog.className = 'mix-picker';
    const headingId = `mix-picker-${crypto.randomUUID()}`;
    this.dialog.setAttribute('aria-labelledby', headingId);
    this.dialog.innerHTML = `<div class="mix-picker__header"><h2 id="${headingId}"></h2><button type="button" class="mix-picker__close">×</button></div><div class="mix-picker__body"></div><div class="mix-picker__footer"><button type="button" class="mix-picker__confirm"></button></div>`;
    this.dialog.querySelector('.mix-picker__close').setAttribute('aria-label', this.dataset.close);
    this.dialog.querySelector('.mix-picker__close').addEventListener('click', () => this.dialog.close());
    this.dialog.querySelector('.mix-picker__confirm').textContent = this.dataset.done;
    this.dialog.querySelector('.mix-picker__confirm').addEventListener('click', () => {
      const select = this.pickerSlot.querySelector('[data-mix-variant]');
      select.value = String(this.pickerVariant.id);
      select.dispatchEvent(new Event('change', {bubbles:true}));
      this.dialog.close();
    });
    this.dialog.addEventListener('click', event => {
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
    });
    this.dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = this.previousOverflow;
      this.pickerTrigger?.focus({preventScroll:true});
    });
    document.body.append(this.dialog);
  }
  openPicker(slot, kind, trigger) {
    this.pickerSlot = slot;
    this.pickerTrigger = trigger;
    this.dialog.querySelector('h2').textContent = kind === 'product' ? this.dataset.chooseProduct : this.dataset.chooseOptions;
    this.dialog.querySelector('.mix-picker__footer').hidden = kind === 'product';
    const body = this.dialog.querySelector('.mix-picker__body');
    body.replaceChildren();
    if (kind === 'product') {
      for (const product of this.catalog) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mix-picker__product';
        button.setAttribute('aria-pressed', String(product.id === this.productFor(slot).id));
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 56;
          image.height = 72;
          button.append(image);
        }
        const title = document.createElement('span');
        title.textContent = product.title;
        button.append(title);
        button.addEventListener('click', () => {
          slot.querySelector('[data-mix-product]').value = String(product.id);
          this.populate(slot);
          this.render();
          this.dialog.close();
        });
        body.append(button);
      }
    } else {
      this.pickerVariant = this.selectedVariant(slot);
      this.renderPickerOptions();
    }
    this.previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    this.dialog.showModal();
    this.dialog.querySelector('.mix-picker__body').scrollTop = 0;
  }
  renderPickerOptions() {
    const product = this.productFor(this.pickerSlot);
    const body = this.dialog.querySelector('.mix-picker__body');
    const focused = this.dialog.querySelector(':focus')?.dataset.optionKey;
    body.replaceChildren();
    if (!this.pickerVariant) {
      body.textContent = this.dataset.unavailable;
      this.dialog.querySelector('.mix-picker__confirm').disabled = true;
      return;
    }
    product.options.forEach((name, index) => {
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = `${name} · ${this.pickerVariant.options[index]}`;
      fieldset.append(legend);
      const choices = document.createElement('div');
      choices.className = 'mix-picker__chips';
      for (const value of new Set(product.variants.map(variant => variant.options[index]))) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = value;
        button.dataset.optionKey = `${index}:${value}`;
        button.setAttribute('aria-pressed', String(this.pickerVariant.options[index] === value));
        button.disabled = !product.variants.some(variant => variant.available && variant.options[index] === value);
        button.addEventListener('click', () => {
          const matches = product.variants.filter(variant => variant.available && variant.options[index] === value);
          this.pickerVariant = matches.find(variant => variant.options.every((option, other) => other === index || option === this.pickerVariant.options[other])) || matches[0];
          this.renderPickerOptions();
        });
        choices.append(button);
      }
      fieldset.append(choices);
      body.append(fieldset);
    });
    const price = document.createElement('p');
    price.className = 'mix-picker__selected';
    price.textContent = `${this.pickerVariant.title} · ${this.money.format(this.pickerVariant.price / 100)}`;
    price.setAttribute('aria-live', 'polite');
    body.append(price);
    this.dialog.querySelector('.mix-picker__confirm').disabled = !this.pickerVariant.available;
    if (focused) [...body.querySelectorAll('[data-option-key]')].find(button => button.dataset.optionKey === focused)?.focus({preventScroll:true});
  }
  productFor(slot) {
    return this.catalog.find(product => String(product.id) === slot.querySelector('[data-mix-product]').value);
  }
  selectedVariant(slot) {
    return this.productFor(slot)?.variants.find(variant => String(variant.id) === slot.querySelector('[data-mix-variant]').value);
  }
  populate(slot, preferred) {
    const product = this.productFor(slot);
    const select = slot.querySelector('[data-mix-variant]');
    select.replaceChildren();
    for (const variant of product.variants) {
      const option = document.createElement('option');
      option.value = variant.id;
      option.disabled = !variant.available;
      option.textContent = `${variant.title} · ${this.money.format(variant.price / 100)}${variant.available ? '' : ` · ${this.dataset.unavailable}`}`;
      select.append(option);
    }
    const selected = product.variants.find(variant => String(variant.id) === String(preferred) && variant.available)
      || product.variants.find(variant => variant.available);
    select.value = selected ? String(selected.id) : '';
  }
  syncQuantity() {
    const quantity = this.pf?.form?.querySelector('input[name="quantity"]');
    if (!quantity) return;
    this.syncing = true;
    quantity.value = this.count;
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
    this.syncing = false;
  }
  getItems() {
    if (this.count === 1) return null;
    if (this.pf?.sellingPlanInput?.value || this.catalog[0].requiresPlan) throw new Error(this.dataset.planError);
    const items = new Map();
    for (const slot of this.slots.slice(0, this.count)) {
      const variant = this.selectedVariant(slot);
      if (!variant?.available) throw new Error(this.dataset.unavailable);
      const item = items.get(variant.id) || { id: variant.id, quantity: 0 };
      item.quantity += 1;
      items.set(variant.id, item);
    }
    for (const item of items.values()) {
      const variant = this.catalog.flatMap(product => product.variants).find(variant => variant.id === item.id);
      if (item.quantity < variant.minimum || (variant.maximum && item.quantity > variant.maximum) || item.quantity % variant.increment !== 0) throw new Error(this.dataset.unavailable);
    }
    return [...items.values()];
  }
  showError(message) {
    const error = this.querySelector('[data-mix-error]');
    error.textContent = message;
    error.hidden = !message;
  }
  render() {
    const active = this.count > 1;
    this.dataset.active = String(active);
    this.querySelector('[data-mix-slots]').hidden = !active;
    let total = 0;
    this.slots.forEach((slot, index) => {
      slot.hidden = !active || index >= this.count;
      const variant = this.selectedVariant(slot);
      const product = this.productFor(slot);
      const productButton = slot.querySelector('[data-mix-choose="product"]');
      const variantButton = slot.querySelector('[data-mix-choose="variant"]');
      if (productButton) { productButton.textContent = product.title; productButton.setAttribute('aria-label', `${this.dataset.chooseProduct}: ${product.title}`); }
      if (variantButton) { variantButton.textContent = variant?.title || this.dataset.unavailable; variantButton.setAttribute('aria-label', `${this.dataset.chooseOptions}: ${variant?.title || this.dataset.unavailable}`); }
      total += index < this.count ? variant?.price || 0 : 0;
      slot.querySelector('[data-mix-price]').textContent = variant ? this.money.format(variant.price / 100) : this.dataset.unavailable;
      const image = slot.querySelector('[data-mix-image]');
      const src = variant?.image || product.image;
      image.hidden = !src;
      if (src && active && index < this.count) { image.src = src; image.alt = `${product.title} — ${variant?.title || ''}`; }
    });
    this.querySelector('[data-mix-total]').textContent = this.money.format(total / 100);
    this.pf?.setAtcPrice?.(active ? total : null);
    if (active) this.pf?.querySelectorAll('[data-sticky-price]').forEach(element => { element.textContent = this.money.format(total / 100); });
    this.pf?.syncAcceleratedCheckout?.();
    try { this.getItems(); this.showError(''); } catch (error) { this.showError(error.message); }
  }
}
if (!customElements.get('nova-mix-match')) customElements.define('nova-mix-match', NovaMixMatch);
